import RadioGroup from '@digitools/honest-react/dist/lib/components/Radio/RadioGroup';
import Radio from '@digitools/honest-react/dist/lib/components/Radio';
import themes from '@digitools/honest-react/dist/lib/theming/themes';
import CommPrefDisplayText from './language/CommPrefDisplayText';
import React from 'react';
import useTranslate from '../../../../hooks/useTranslate';
const DeliveryMethodRadioButtons = (props) => {
    const { t } = useTranslate();
    const validateDeliveryMethod = (values) => {
        if (props.toggleOn) {
            if (values === undefined) {
                return t({ english: 'This is required.', spanish: 'Este es obligatorio.' });
            }
        }
        return undefined;
    };
    return (props.toggleOn ?
        <RadioGroup id={props.radioGroupId} aria-labelledby={props.radioGroupLabelId} isRequired={true} field={'deliveryMethod'} theme={themes.rebrand} initialValue={props.toggleOn && props.deliveryMethod ? (props.deliveryMethod === 'TXT' ? 'textNotification' : 'phoneCall') : undefined} validateOnBlur={true} validateOnChange={true}>
        <Radio name={'deliveryMethod'} id={'textNotification'} label={t(CommPrefDisplayText.textNotification)} aria-label={t(CommPrefDisplayText.textNotification)} value={'textNotification'} theme={themes.rebrand} disabled={!props.toggleOn} containerStyle={{ marginBottom: '0.5rem' }} data-testid={'delivery-method-text-notification'}/>
        <Radio name={'deliveryMethod'} id={'phoneCall'} label={t(CommPrefDisplayText.phoneCall)} aria-label={t(CommPrefDisplayText.phoneCall)} value={'phoneCall'} theme={themes.rebrand} disabled={!props.toggleOn} containerStyle={{ marginBottom: '0.5rem' }} data-testid={'delivery-method-phone-call'}/>
      </RadioGroup>
        : <>
          <span style={{ color: themes.rebrand.palette.gray }}>{t(CommPrefDisplayText.textNotification)}</span>
          <span style={{ color: themes.rebrand.palette.gray }}>{t(CommPrefDisplayText.phoneCall)}</span>
        </>);
};
export default DeliveryMethodRadioButtons;
